// extracted by css-extract-rspack-plugin
export default {"loaderContainer":"index__loaderContainer___B3xfV","loader":"index__loader____AALy","load8":"index__load8___efEm3","logoLoader":"index__logoLoader___aSYB1"};